import { render, staticRenderFns } from "./ScrollDots.vue?vue&type=template&id=094bb491&scoped=true"
import script from "./ScrollDots.vue?vue&type=script&lang=js"
export * from "./ScrollDots.vue?vue&type=script&lang=js"
import style0 from "./ScrollDots.vue?vue&type=style&index=0&id=094bb491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094bb491",
  null
  
)

export default component.exports